export default __webpack_public_path__ + "static/media/ocean-icon.b238cf69.png";